import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { selectClasses } from "src/components/SelectV2/SelectV2.constants.ts";
import React, { type MouseEvent } from "react";

export const ClearButton = ({ onReset }: { onReset?: () => void }) => {
  return (
    <div
      css={styles.resetContainer}
      className={selectClasses.clearButtonContainer}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        e.stopPropagation();
        onReset?.();
      }}
    >
      <div
        className={selectClasses.clearButton}
        css={styles.resetIconContainer}
      >
        <i className="icon-15-clear_x" />
      </div>
    </div>
  );
};
